<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> Volver
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              Crear nueva taxonomía
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="3">
              <b-form-group label-for="clase">
                <template v-slot:label>
                  Clase <span class="text-danger">*</span>
                </template>
                <b-form-input id="clase" v-model="form.clase" required
                  placeholder="Clase"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="segmento">
                <template v-slot:label>
                  Segmento <span class="text-danger">*</span>
                </template>
                <b-form-input id="segmento" v-model="form.segmento" required
                  placeholder="Segmento"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="familia">
                <template v-slot:label>
                  Familia <span class="text-danger">*</span>
                </template>
                <b-form-input id="familia" v-model="form.familia" required
                  placeholder="Familia"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="categoria">
                <template v-slot:label>
                  Categoría <span class="text-danger">*</span>
                </template>
                <b-form-input id="categoria" v-model="form.categoria" required
                  placeholder="Categoría"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label-for="claseIngles">
                <template v-slot:label>
                  Clase (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input id="claseIngles" v-model="form.claseIngles" required
                  placeholder="Clase (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="segmentoIngles">
                <template v-slot:label>
                  Segmento (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input id="segmentoIngles" v-model="form.segmentoIngles" required
                  placeholder="Segmento (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="familiaIngles">
                <template v-slot:label>
                  Familia (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input id="familiaIngles" v-model="form.familiaIngles" required
                  placeholder="Familia (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="categoriaIngles">
                <template v-slot:label>
                  Categoría (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input id="categoriaIngles" v-model="form.categoriaIngles" required
                  placeholder="Categoría (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label-for="accion" label="Acción">
                <b-form-input id="accion" v-model="form.accion"
                  placeholder="Acción"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="version" label="Versión">
                <b-form-input id="version" v-model="form.version"
                  placeholder="Versión"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="actualizacion" label="Actualización">
                <b-form-input id="actualizacion" v-model="form.actualizacion"
                  placeholder="Actualización"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            Guardar
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import taxonomiaService from '@/api/taxonomiaService';
import Swal from 'sweetalert2';

export default {
  name: 'TaxonomiaCrear',
  data() {
    return {
      form: {
        segmento: '',
        familia: '',
        categoria: '',
        clase: '',
        version: '',
        segmentoIngles: '',
        familiaIngles: '',
        categoriaIngles: '',
        claseIngles: '',
        accion: '',
        actualizacion: '',
      },
    };
  },
  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: '¿Está seguro?',
        text: 'Revisa los datos antes de continuar.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Crear Taxonomía',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">Creando...</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await taxonomiaService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: 'Creado correctamente',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          this.$router.push({ name: 'taxonomias' });
        } catch (error) {
          const raw = (error && error.response) ? error.response.data : error;
          try { console.error('Create taxonomia error payload:', raw); } catch (e) { /* noop */ }

          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }

          let msg = 'Error';
          if (typeof raw === 'string') {
            msg = raw;
          } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
            msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
          } else if (error && error.message) {
            msg = error.message;
          } else {
            try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
          }

          const title = (status === 409) ? 'La taxonomía ya existe' :
                        (status === 400) ? 'Datos inválidos' : 'Oops...';
          const icon  = (status === 409 || status === 400) ? 'warning' : 'error';

          Swal.fire({
            icon: icon,
            title: title,
            html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">' + msg + '</pre>',
          });
        }
      });
    },
  },
};
</script>
